import { createContext, useContext, useMemo, PropsWithChildren } from "react";

interface ArticleContextType {
  author?: string;
  sport?: string;
  title?: string;
  sportSlug?: string;
}

export const ArticleContext = createContext<ArticleContextType>({});

export const ArticleContextProvider = ({
  author,
  sport,
  sportSlug,
  title,
  children,
}: PropsWithChildren<ArticleContextType>) => {
  const articleInfo = useMemo(
    () => ({ author, sport, sportSlug, title }),
    [author, sport, sportSlug, title]
  );

  return (
    <ArticleContext.Provider value={articleInfo}>
      {children}
    </ArticleContext.Provider>
  );
};

export const useArticleInfo = () => {
  const articleInfo = useContext(ArticleContext);
  return articleInfo ?? {};
};
